<div class="alert alert-info"
     role="alert">
    <ng-content></ng-content>
    <a *ngIf="url"
       href="{{url}}"
       rel="noreferrer noopener"
       target="_blank">{{text}}</a>
</div>
